import styled from 'styled-components';

export const Descr = styled.span`
  display: inline-block;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.limedSpruce};
`;
